import { render, staticRenderFns } from "./MatrixForm.vue?vue&type=template&id=0c444474&scoped=true"
import script from "./MatrixForm.vue?vue&type=script&lang=js"
export * from "./MatrixForm.vue?vue&type=script&lang=js"
import style0 from "./MatrixForm.vue?vue&type=style&index=0&id=0c444474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c444474",
  null
  
)

export default component.exports